'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegionPicker = function (_React$Component) {
    _inherits(RegionPicker, _React$Component);

    function RegionPicker(props) {
        _classCallCheck(this, RegionPicker);

        var _this = _possibleConstructorReturn(this, (RegionPicker.__proto__ || Object.getPrototypeOf(RegionPicker)).call(this, props));

        _this.state = {
            regionvalue: false,
            centervalue: false,
            subcentervalue: false
        };

        _this.onChange = function () {
            if (_this.props.onChange) {
                var regionMatch = _this.props.regions.find(function (r) {
                    return r.id === _this.state.regionvalue;
                });
                var centerMatch = false;
                if (regionMatch) {
                    centerMatch = regionMatch.centers.find(function (c) {
                        return c.id === _this.state.centervalue;
                    });
                }
                if (_this.state && _this.state.subcentervalue) {
                    centerMatch = regionMatch.centers.find(function (c) {
                        return c.id === _this.state.subcentervalue;
                    });
                }
                if (centerMatch) {
                    centerMatch = centerMatch.name;
                    if (_this.state && !_this.state.subcentervalue) {
                        centerMatch = centerMatch.split(' || ')[0];
                    }
                }

                var regionCenterMatch = [regionMatch ? regionMatch.name : '', centerMatch ? ' : ' + centerMatch.replace(' || ', ' : ') : ''].join('');
                _this.props.onChange(regionCenterMatch);
            }
        };

        _this.handleRegionChange = function (event) {
            if (!event) return;
            var regionvalue = event.target.value;
            var centervalue = false;
            var subcentervalue = false;
            _this.setState(Object.assign({}, _this.state, { regionvalue: regionvalue, centervalue: centervalue, subcentervalue: subcentervalue }), _this.onChange);
        };

        _this.handleCenterChange = function (event) {
            if (!event) return;
            var centervalue = event.target.value;
            var subcentervalue = false;
            if (!!centervalue) {
                _this.setState(Object.assign({}, _this.state, { centervalue: centervalue, subcentervalue: subcentervalue }), _this.onChange);
            }
        };

        _this.handleSubCenterChange = function (event) {
            if (!event) return;
            var subcentervalue = event.target.value;
            if (!!subcentervalue) {
                _this.setState(Object.assign({}, _this.state, { subcentervalue: subcentervalue }), _this.onChange);
            }
        };

        _this.inputId = _shortid2.default.generate();
        _this.state = {
            value: 'choose',
            error: _this.props.error,
            hasFocus: false
        };

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(RegionPicker, [{
        key: 'renderCenters',
        value: function renderCenters() {
            var _ref = this.state || {},
                regionvalue = _ref.regionvalue,
                centervalue = _ref.centervalue;

            var _ref2 = this.props || {},
                regions = _ref2.regions;

            if (regionvalue) {
                var selectedRegion = regions.find(function (r) {
                    return r.id === regionvalue;
                });
                if (selectedRegion) {
                    var virtualRegion = Object.assign({}, selectedRegion);
                    return virtualRegion.centers.filter(function (elem, pos, arr) {
                        return arr.map(function (mapObj) {
                            return mapObj.name.split(' || ')[0];
                        }).indexOf(elem.name.split(' || ')[0]) === pos;
                    }).map(function (center, index) {
                        return _react2.default.createElement(
                            'option',
                            { key: center.id + 'rcenterselectfield' + index, value: center.id },
                            center.name.split(' || ')[0],
                            ' '
                        );
                    });
                }
            }
        }
    }, {
        key: 'renderSubCenters',
        value: function renderSubCenters() {
            var _ref3 = this.state || {},
                regionvalue = _ref3.regionvalue,
                centervalue = _ref3.centervalue;

            var _ref4 = this.props || {},
                regions = _ref4.regions,
                centerLabel = _ref4.centerLabel,
                error = _ref4.error;

            var parsedSubCenterLabel = centerLabel.split(' || ').length > 1 ? centerLabel.split(' || ')[1] : false;
            var defaultStyles = { 'width': '100%' };
            if (centervalue) {
                var selectedRegion = regions.find(function (r) {
                    return r.id === regionvalue;
                });
                var virtualRegion = Object.assign({}, selectedRegion);
                if (!virtualRegion.centers) return;
                var mappedCenters = virtualRegion.centers.filter(function (c) {
                    var selectedCenter = virtualRegion.centers.find(function (r) {
                        return r.id === centervalue;
                    });
                    if (selectedCenter) {
                        return c.name.indexOf(selectedCenter.name.split(' || ')[0] + ' || ') === 0;
                    }
                });

                if (selectedRegion && mappedCenters.length) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'wsequiz_selectfield' + (error ? ' wsequiz_error' : '') },
                        _react2.default.createElement(
                            'select',
                            {
                                style: defaultStyles,
                                name: 'subcenterselectfield',
                                onChange: this.handleSubCenterChange,
                                disabled: !!centervalue ? false : 'disabled'
                            },
                            _react2.default.createElement(
                                'option',
                                null,
                                parsedSubCenterLabel || 'Select Option'
                            ),
                            mappedCenters.map(function (c) {
                                c.newName = c.name;
                                if (c.name.indexOf(' || ') > -1) {
                                    c.newName = c.name.split(' || ')[1];
                                    return c;
                                }
                                debugger;
                                return false;
                            }).filter(function (elem, pos, arr) {
                                return !!elem && arr.map(function (mapObj) {
                                    return mapObj.newName;
                                }).indexOf(elem.newName) === pos;
                            }).map(function (center, index) {
                                return _react2.default.createElement(
                                    'option',
                                    { key: center.id + 'rcenterselectfield' + index, value: center.id },
                                    center.newName,
                                    ' '
                                );
                            })
                        ),
                        _react2.default.createElement('hr', { 'aria-hidden': true }),
                        _react2.default.createElement('hr', { 'aria-hidden': true })
                    );
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _ref5 = this.state || {},
                regionvalue = _ref5.regionvalue,
                centervalue = _ref5.centervalue;

            var _ref6 = this.props || {},
                regions = _ref6.regions,
                error = _ref6.error,
                regionLabel = _ref6.regionLabel,
                centerLabel = _ref6.centerLabel;

            var defaultStyles = { 'width': '100%' };
            var parsedCenterLabel = centerLabel.split(' || ')[0];
            return _react2.default.createElement(
                'div',
                { className: 'wsequiz_selectfield-wrapper' + (error ? ' wsequiz_error' : '') },
                _react2.default.createElement(
                    'span',
                    { className: 'wsequiz_selectlabel' },
                    this.props.text,
                    ' ',
                    _react2.default.createElement(
                        'span',
                        null,
                        this.props.subtext
                    ),
                    error ? '*' : ''
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'wsequiz_selectfield' + (error ? ' wsequiz_error' : '') + (!regionvalue ? ' wsequiz_unselected' : '') },
                    _react2.default.createElement(
                        'select',
                        {
                            defaultValue: regionvalue || false,
                            name: 'regionselect',
                            onChange: this.handleRegionChange,
                            style: defaultStyles
                        },
                        _react2.default.createElement(
                            'option',
                            null,
                            regionLabel || 'Select Region'
                        ),
                        (regions || []).map(function (region, index) {
                            return _react2.default.createElement(
                                'option',
                                { key: region.id + 'r' + index, value: region.id },
                                region.name,
                                ' '
                            );
                        })
                    ),
                    _react2.default.createElement('hr', { 'aria-hidden': true }),
                    _react2.default.createElement('hr', { 'aria-hidden': true })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'wsequiz_selectfield' + (!!regionvalue ? '' : ' wsequiz_selectfield-disabled') + (error ? ' wsequiz_error' : '') + (!centervalue ? ' wsequiz_unselected' : '') },
                    _react2.default.createElement(
                        'select',
                        {
                            defaultValue: centervalue || false,
                            style: defaultStyles,
                            name: 'centerselectfield',
                            onChange: this.handleCenterChange,
                            disabled: !!regionvalue ? false : 'disabled'
                        },
                        _react2.default.createElement(
                            'option',
                            null,
                            parsedCenterLabel || 'Select Center'
                        ),
                        this.renderCenters()
                    ),
                    _react2.default.createElement('hr', { 'aria-hidden': true }),
                    _react2.default.createElement('hr', { 'aria-hidden': true })
                ),
                this.renderSubCenters()
            );
        }
    }]);

    return RegionPicker;
}(_react2.default.Component);

exports.default = RegionPicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/blocks/RegionPicker.js
// module id = 829
// module chunks = 0